module.exports = __webpack_public_path__ + "img/codingsubmitted.935cbb7e.svg";